<script setup lang="ts">
import { ref, watch } from 'vue';
import clsx from 'clsx';

const props = defineProps<{
  modelValue?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  class?: string;
}>();

const emit = defineEmits<{ 'update:modelValue': [value: boolean] }>();

const input = ref<HTMLInputElement | null>(null);

watch(
  () => props.indeterminate,
  (v) => {
    if (input.value) input.value.indeterminate = !!v;
  },
  { immediate: true, flush: 'post' },
);

function onChange(e: Event) {
  emit('update:modelValue', (e.target as HTMLInputElement).checked);
}

const classes = clsx(
  'size-4 rounded border-zinc-950/20 bg-white text-zinc-900 shadow-sm',
  'focus:ring-2 focus:ring-blue-500 focus:ring-offset-0',
  'dark:border-white/15 dark:bg-zinc-900 dark:checked:bg-white dark:checked:text-zinc-900',
  'disabled:opacity-50',
  props.class,
);
</script>

<template>
  <input
    ref="input"
    type="checkbox"
    :checked="!!modelValue"
    :disabled="disabled"
    :class="classes"
    @change="onChange"
  />
</template>
